import { Svg, Path, Rect } from "@react-pdf/renderer";

const LogoPDF = () => (
  <Svg width={50} height={50} viewBox="0 0 173 120">
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M113.354 0.000183105L54.5078 58.8464L113.354 117.693L172.2 58.8464L113.354 0.000183105ZM103.216 71.7081V58.4718H113.852L121.917 70.2179C122.832 71.562 123.29 72.4094 123.29 72.76C123.29 73.3054 122.793 73.6561 121.8 73.8119V74.7469H136.234V73.8119C135.319 73.7534 134.539 73.4515 133.897 72.9061C133.273 72.3412 132.28 71.0945 130.916 69.166L123.173 58.1504C130.4 57.04 134.013 53.2318 134.013 46.7256C134.013 44.8166 133.653 43.0245 132.932 41.3493C132.173 39.6156 131.023 38.2423 129.484 37.2294C128.16 36.3528 126.601 35.7392 124.809 35.3885C123.037 35.0379 120.631 34.8626 117.592 34.8626H92.6389V35.7976C93.3402 35.9924 93.8271 36.2456 94.0999 36.5573C94.3726 36.869 94.5089 37.3268 94.5089 37.9306V71.7081C94.5089 72.2925 94.3726 72.7405 94.0999 73.0522C93.8271 73.3639 93.3402 73.6171 92.6389 73.8119V74.7469H105.086V73.8119C104.405 73.6366 103.918 73.3931 103.625 73.0814C103.353 72.7503 103.216 72.2925 103.216 71.7081ZM116.657 51.8974H103.216V41.4369H116.657C118.683 41.4369 120.086 41.4954 120.865 41.6122C121.663 41.7096 122.413 41.9531 123.115 42.3427C124.595 43.1414 125.335 44.5829 125.335 46.6672C125.335 48.7515 124.595 50.193 123.115 50.9916C122.433 51.3617 121.683 51.6052 120.865 51.7221C120.047 51.839 118.644 51.8974 116.657 51.8974Z"
      fill="#081E56"
    />
    <Rect
      width="84.0637"
      height="10.7945"
      transform="matrix(0.707106 -0.707108 0.707106 0.707108 0.797852 59.4423)"
      fill="#081E56"
    />
    <Rect
      width="84.0637"
      height="10.7945"
      transform="matrix(0.707106 -0.707108 0.707106 0.707108 14.1963 72.8404)"
      fill="#081E56"
    />
    <Rect
      width="76.5897"
      height="10.7945"
      transform="matrix(0.707106 -0.707108 0.707106 0.707108 27.3721 86.0154)"
      fill="#081E56"
    />
    <Rect
      width="62.8042"
      height="10.7945"
      transform="matrix(0.707106 -0.707108 0.707106 0.707108 40.5479 99.1909)"
      fill="#081E56"
    />
    <Rect
      width="45.5607"
      height="10.7945"
      transform="matrix(0.707106 -0.707108 0.707106 0.707108 53.7236 112.366)"
      fill="#081E56"
    />
  </Svg>
);

export default LogoPDF;
